module.exports = __webpack_public_path__ + "img/henxian-you.6d599339.gif";